module.exports = __webpack_public_path__ + "img/ticket.d015283b.svg";